import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons';

class ResetFormComponentDefaults extends React.Component {
  render() {
    const { resetDefaults, value } = this.props;
    return (
      <span>
        <Button outline color="link" size="sm" className="text-black-50 font-weight-light bg-transparent"
                onClick={resetDefaults}
        >
        <FontAwesomeIcon size="sm" id={value} icon={faUndoAlt}/>{' '}
          Atstatyti
        </Button>
      </span>
    );
  }
}

export default ResetFormComponentDefaults;

